import { getOuterBgCode } from '@service/common';
import { getQueryString, Object2Query } from './tools';

interface IPathObj {
  staffSsoId?: string;
  jobShareType?: string;
  token?: string;
  bg?: string;
}

// 修改校招bg映射，线上和测试环境可能切换校招项目，所以调接口，将_token修改为token，删除其他不需要参数，
export default async function redirectHandler() {
  // const { origin, pathname } = window.location;
  const { pathname } = window.location;
  const fromAppKey = getQueryString('appKey');
  const _token = getQueryString('_token');
  const jobShareType = getQueryString('jobShareType');
  const staffSsoId = getQueryString('staffSsoId');
  const bg = getQueryString('bg');

  // 以fromAppKey做标识， 有fromAppKey才修改url参数，修改后不带fromAppKey，否则刷新时不知道该不该修改url
  if (!fromAppKey) {
    return false;
  }

  const pathObj: IPathObj = {};
  if (staffSsoId) {
    pathObj.staffSsoId = staffSsoId;
  }
  if (jobShareType) {
    pathObj.jobShareType = jobShareType;
  }
  if (_token && _token !== 'null') {
    pathObj.token = _token;
  }
  if (bg && bg !== 'null') {
    try {
      pathObj.bg = await getOuterBgCode(bg);
    } catch (error) {
      console.error('获取bg映射失败');
    }
  }
  const newSearch = Object2Query(pathObj);
  const newUrlPath = `${pathname}${newSearch ? '?' : ''}${newSearch}`;
  // ios 微信环境使用replaceState替换后_token没有改变，改成replace方法
  // window.location.replace(`${origin}${newUrlPath}`);
  window.history.replaceState(window.history.state, '', newUrlPath);
  await new Promise<string>((resolve) => {
    setTimeout(() => {
      resolve('');
    }, 20);
  });
  return true;

  // if (appKey === 'hiring-campus-portal') {
  //   console.log('2', _token, appKey, pathname);

  //   switch (pathname) {
  //     case '/web/mobile/':
  //       console.log('3', _token, appKey);
  //       window.location.href = `${prefix}/m/campus`;
  //       return false;
  //     case '/web/bole/wechat':
  //       window.location.href = `${prefix}/m/campus?jobShareType=1${bg ? `&department=${bg}` : ''}`;
  //       return false;
  //     case '/web/bole/wechat/jobList':
  //       window.location.href = `${prefix}/m/share-position?jobShareType=4&token=${_token}`;
  //       return false;
  //     case '/web/mobile/jobList':
  //       window.location.href = `${prefix}/m/share-position?jobShareType=5&token=${_token}`;
  //       return false;
  //     case '/web/recruit':
  //       window.location.href = `${prefix}/web/campus/schedule`;
  //       return false;
  //     case '/web/jobs':
  //       window.location.href = `${prefix}/web/position${hiringType}`;
  //       return false;
  //     case '/web/recruit-qa':
  //       window.location.href = `${prefix}/web/question/campus`;
  //       return false;
  //     case '/web/internship':
  //       // todo
  //       return false;
  //     case '/web/beidou':
  //       window.location.href = `${prefix}/web/beidou`;
  //       return false;
  //     case '/web/qihang':
  //       window.location.href = `${prefix}/web/qihang`;
  //       return false;
  //     case '/web/good-life/welfare':
  //       // 校招美好生活
  //       return false;
  //   }
  // }

  // if (appKey === 'zhaopin-app-social') {
  //   switch (pathname) {
  //     case '/web/wechat':
  //       window.location.href = `${prefix}/m/share-position?jobShareType=2&token=${_token}`;
  //       return false;
  //     case '/web/mobile':
  //       if (!_token) {
  //         window.location.href = `${prefix}/m/social`;
  //         return false;
  //       }
  //       window.location.href = `${prefix}/m/share-position?jobShareType=3&token=${_token}`;
  //       return false;
  //   }
  // }
  // console.log('5', _token, appKey, pathname);

  // switch (pathname) {
  //   case '/web/mobile/beidou':
  //     console.log('6', _token, appKey);

  //     window.location.href = `${prefix}/m/beidou`;
  //     return false;
  //   case '/web/mobile/qihang':
  //     window.location.href = `${prefix}/m/qihang`;
  //     return false;
  //   case '/web/mobileweb/personal-center':
  //     window.location.href = `${prefix}/m/personalCenter/resumeDetail?type=campus&mode=view`;
  //     return false;
  //   case '/web/job-list':
  //     window.location.href = `${prefix}/web/social`;
  //     return false;
  //   case '/web/good-life':
  //     // 社招美好生活
  //     return false;
  // }

  // return true;
}
